import { GetterTree } from 'vuex';
import { ContractsState, ContractPaginator } from './types';
import { RootState } from '@/types';

export const getters: GetterTree<ContractsState, RootState> = {
    contracts(state): ContractPaginator | undefined {
        const contracts  = state.data || undefined;
        return contracts;
    },
};
